import { BundleKey } from "./../../translation/bundleKey";
import * as yup from "yup";

export const loginSchema = (translate?: any) => {
  const schema = yup.object().shape({
    email: yup
      .string()
      .required(translate(BundleKey.LOGIN_INPUT_EMAIL_ERROR_MUST))
      .email(translate(BundleKey.LOGIN_INPUT_EMAIL_ERROR)),
    password: yup
      .string()
      .required(translate(BundleKey.LOGIN_INPUT_PASSWORD_ERROR_MUST)),
  });
  return schema;
};
